/**
 * Static data for the bid comparison debug preview (/demo/bid-comparison?debug=true).
 * Shapes align with vendor-bids API + Firestore vendorBids fields used in RepairTicketNegotiationView.
 */
export const BID_COMPARISON_SCREENSHOT_TICKET_ID = "__lo_bid_comparison_preview__";

const iso = (hoursAgo) => {
  const d = new Date();
  d.setHours(d.getHours() - hoursAgo);
  return d.toISOString();
};

export function getScreenshotMockTicket(ownerUid) {
  return {
    id: BID_COMPARISON_SCREENSHOT_TICKET_ID,
    title: "Kitchen sink leak under cabinet",
    description:
      "Steady drip from supply line. Tenant shut off angle stop. Needs assessment and repair.",
    category: "plumbing",
    priority: "high",
    unitNumber: "2B",
    ownerId: ownerUid,
    landlordId: ownerUid,
  };
}

export function getScreenshotMockBids() {
  return [
    {
      id: "mock-bid-summit",
      status: "pending",
      vendorName: "Summit Plumbing Co.",
      vendorIsPreferred: true,
      bidAmount: 425,
      final_bid_amount: 425,
      timeline: "Within 24 hours",
      submittedAt: iso(2),
      negotiation_log: [
        {
          role: "leo",
          content:
            "Hi. Quick summary for this job: leak under the kitchen sink at unit 2B, angle stop closed. Can you confirm you can attend within 24h and your ballpark range?",
          createdAt: iso(3),
        },
        {
          role: "vendor",
          content:
            "Yes, we can be there tomorrow morning. Likely supply line or valve. Estimate $400 to $450 parts and labor depending on what we find.",
          createdAt: iso(2.5),
        },
        {
          role: "leo",
          content:
            "Thanks. Please submit your formal bid with final price and timeline in the form when ready.",
          createdAt: iso(2.2),
        },
      ],
    },
    {
      id: "mock-bid-quickfix",
      status: "pending",
      vendorName: "QuickFix Services",
      vendorIsPreferred: false,
      bidAmount: 380,
      final_bid_amount: 380,
      timeline: "2-3 days",
      submittedAt: iso(5),
      negotiation_log: [
        {
          role: "leo",
          content:
            "Tenant-reported kitchen sink leak, water stopped at angle stop. Looking for bid and earliest availability.",
          createdAt: iso(6),
        },
        {
          role: "vendor",
          content:
            "We can schedule in 2 to 3 days. $380 covers typical supply line replacement and labor.",
          createdAt: iso(5),
        },
      ],
    },
    {
      id: "mock-bid-metro",
      status: "pending",
      vendorName: "Metro Rooter & Pipe",
      vendorIsPreferred: false,
      bidAmount: 510,
      final_bid_amount: 510,
      timeline: "1-2 days",
      submittedAt: iso(4),
      negotiation_log: [
        {
          role: "vendor",
          content:
            "We can prioritize this for $510, including diagnostic, parts, and same-week completion.",
          createdAt: iso(4),
        },
      ],
    },
  ];
}
